import React from 'react';

const Unauthorized: React.FC = () => {
  return <div className="app flex-row align-items-center">unauthorized</div>;
};

export default Unauthorized;
